// Resolves on the first user interaction (scroll, pointerdown, keydown, touchstart)
// or after a timeout, whichever comes first. Used to defer loading third-party
// scripts (AdSense, Firebase/gtag) until the user shows intent or a reasonable
// time has passed, reducing TBT from their initial load.
//
// Listeners are passive and removed after the first trigger to avoid keeping
// the interaction handlers in memory.
export function whenUserInteractsOrTimeout(ms: number): Promise<void> {
  return new Promise((resolve) => {
    let triggered = false;

    const trigger = () => {
      if (triggered) return;
      triggered = true;
      cleanup();
      resolve();
    };

    const cleanup = () => {
      document.removeEventListener('scroll', trigger, { passive: true } as EventListenerOptions);
      document.removeEventListener('pointerdown', trigger, { passive: true } as EventListenerOptions);
      document.removeEventListener('keydown', trigger, { passive: true } as EventListenerOptions);
      document.removeEventListener('touchstart', trigger, { passive: true } as EventListenerOptions);
      clearTimeout(timeoutId);
    };

    const timeoutId = setTimeout(trigger, ms);

    // Passive listeners ensure they don't block scrolling or pointer events
    document.addEventListener('scroll', trigger, { passive: true } as EventListenerOptions);
    document.addEventListener('pointerdown', trigger, { passive: true } as EventListenerOptions);
    document.addEventListener('keydown', trigger, { passive: true } as EventListenerOptions);
    document.addEventListener('touchstart', trigger, { passive: true } as EventListenerOptions);
  });
}
